import { Typography } from "@material-ui/core";
import React, { useEffect } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import { setBackground } from "../../actions/Layout";
import cuideoTheme from "../../containers/themes/defaultTheme";
import usePageTitle from "../../util/usePageTitle";

const StyledWrapper = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const StyledHeader = styled(Typography)`
  text-align: center;
  font-size: 1.75rem;
  font-family: "Lora", Georgia, serif;
  font-weight: 600;
  max-width: 24rem;
  margin: 0 auto 2rem;
  color: ${cuideoTheme.palette.primary.main};
`;

const StyledText = styled(Typography)`
  text-align: center;
  font-size: 1.1rem;
  line-height: 1.35;
  max-width: 24rem;
  margin: 0 auto;
  color: ${cuideoTheme.palette.primary.main};
`;

const MaintenancePage = () => {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();

  useEffect(() => {
    dispatch(setBackground("cuideo"));
    // eslint-disable-next-line
  }, []);

  usePageTitle(
    formatMessage({
      id: "MaintenancePage.PageTitle",
      defaultMessage: "Mantenimiento",
    })
  );

  return (
    <StyledWrapper>
      <StyledHeader>
        <FormattedMessage
          id="MaintenancePage.Title"
          defaultMessage="Estamos en mantenimiento"
        />
      </StyledHeader>
      <StyledText>
        <FormattedMessage
          id="MaintenancePage.Message"
          defaultMessage="Estamos realizando tareas de mantenimiento. Vuelve a intentarlo en unos minutos."
        />
      </StyledText>
    </StyledWrapper>
  );
};

export default MaintenancePage;
